"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocationFromIP = void 0;
const APIExecutor_1 = require("../APIExecutor");
const getLocationFromIP = async () => {
    const url = "https://ipgeolocation.abstractapi.com/v1/?api_key=4bd1d90c5aa84b53842da3225bc5dbff";
    const response = await (0, APIExecutor_1.executeRequest)(url, { method: "GET" });
    if (response.data) {
        return response.data;
    }
    return null;
};
exports.getLocationFromIP = getLocationFromIP;
//# sourceMappingURL=LocationFromIP.js.map